var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.197 4.47v.444c.454.367.744.928.744 1.557v3.45a2 2 0 01-2 2H2a2 2 0 01-2-2v-3.45c0-.63.29-1.191.745-1.558L.744 4.47h7.453zM6.051 6.06H3.16l-.18.746h.835c.297.004.503.1.616.29l.044.088H3.14l-.16.608h1.514c-.085.271-.283.422-.591.452l-.121.005h-.728l.003.54 1.486 1.742H5.56v-.043l-1.342-1.59c.368-.072.65-.198.847-.378a1.15 1.15 0 00.336-.58l.03-.148h.457l.163-.608h-.617a1.37 1.37 0 00-.12-.398l-.065-.115h.642l.16-.61zM4.47 0a3.725 3.725 0 013.725 3.725v.373h-1.49v-.373a2.235 2.235 0 00-4.464-.159l-.006.16v.372H.745v-.373A3.726 3.726 0 014.471 0z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default SvgWhiteLock;